import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Card, Tabs, AppProvider, Page, Frame } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import TookanApiFormContainer from './TookanApiFormContainer';
import UnimartDeliveryLogin from './UnimartDeliveryLogin';
import BrightPearlLogin from './BrightPearlLogin';

const propTypes = {
  tookanApiKey: PropTypes.string,
  unimartDeliveryActive: PropTypes.bool,

  brightPearl: PropTypes.shape({
    active: PropTypes.bool,
    submitURL: PropTypes.string.isRequired,
    webhooks: PropTypes.array.isRequired,
    webhooksSubmitURL: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {

}


const IntegrationsContainer = (props) => {
  const [selected, setSelected] = useState(0);
  const [loading, setLoading] = useState(false);

  const tabs = [
    { id: "tookan", content: "Tookan" },
    { id: "unimartDelivery", content: "Unimart Delivery" },
    { id: "brightPearl", content: "Brightpearl" },
  ]

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    [],
  );

  return(
    <AppProvider i18n={translations}>
      <Frame>
        <Page
          title="Integraciones"
          breadcrumbs={[{content: I18n.t("actions.back"), url: '/'}]}
        >
          <Card>
            <Tabs
              tabs={tabs} selected={selected} onSelect={handleTabChange}>
              <Card.Section>
                
                { selected == 0 && <TookanApiFormContainer apiKey={ props.tookanApiKey } submitURL={ props.tookanSubmitURL } /> }
                { selected == 1 && <UnimartDeliveryLogin tokenPresent={ props.unimartDeliveryActive } submitURL={ props.unimartDeliverySubmitURL } setLoading={setLoading} loading={loading} /> }
                { selected == 2 && <BrightPearlLogin setLoading={setLoading} loading={loading} {...props.brightPearl} /> }
      
              </Card.Section>
            </Tabs>
          </Card> 
        </Page> 
      </Frame>
    </AppProvider>
  );
};

IntegrationsContainer.propTypes = propTypes;
IntegrationsContainer.defaultProps = defaultProps;

export default IntegrationsContainer;